const f = {
  color: {
    background: "#ffffffff",
    icon: "#405261ff",
    text: "#556575ff",
    prefix: "#abb9c7ff",
    button: {
      mainColor: "#304ddbff",
      color: "#fff"
    }
  }
};
export {
  f as copyValue
};
